export function parseSearchQuery<T extends { [key: string]: string }>(
    sq: string
): T {
    const parts = sq.slice(1).split("&");
    const query: { [key: string]: string } = {};
    parts.forEach((p) => {
        const [key, value] = p.split("=");
        query[key] = value;
    });
    return query as T;
}
